<template>
  <header class="flex justify-center items-center flex-wrap">
    <img src="@/assets/img/chato-animation.gif" alt="" class="mx-2 h-[60px] md:h-[50px]" />
  </header>
  <div class="mt-[32px] text-center text-[#3d3d3d] text-base">
    <!--    <p>{{ $t('基于 AI 技术轻松创建对话机器人') }}</p>-->
    <p>
      {{ $t('限时') }}
      <span class="text-[#596780] font-medium"> {{ $t('免费赠送') }} </span>
      100
      {{ $t('电力值') }}
    </p>
  </div>
</template>
